import ValidService from "../../../service/ValidService";
let model = {};

model.dataForm = {
    id: null, // optional
    duyet: // optional
    {
        duoc_duyet: null, // required Cho biết dịch vụ đã được duyệt hay chưa. 0: đã duyệt, 1: chờ xử lý, 2: Từ chối
        thoi_diem_duoc_duyet: null, // optional Cho biết thời điểm dịch vụ đã được duyệt
        nguoi_duyet_id: null, // optional Mã người duyệt
    },
    mo_ta: null, // optional Mô tả vận tải khách
    chi_tiet: null, // optional Chi tiết về quán
    diem_den: null, // optional Điểm đến
    thong_tin_chung: // required Thông tin vận tải khách
    {
        ten: null, // required Tên nhà hàng
        so_sao: null, // optional Số sao của địa điểm vận tải khách
        dia_chi: null, // optional Địa chỉ khách sạn - nhà hàng
        dien_thoai: null, // required Điện thoại liên hệ khách sạn - nhà hàng
        email: null, // optional Email liên hệ khách sạn - nhà hàng
        website: null, // optional Website khách sạn - nhà hàng
        doi_tuong: null, // optional Đối tượng khách hàng hướng tới
        dich_vu: [], // optional
    },
    thoi_gian_tao: null, // optional
    mediaId: null, // optional id media
    lastModificationTime: null, // optional Thời gian lần sửa bản ghi cuối cùng
};

// dữ liệu mẫu các form khác
model.dataFormOther = {
    id: null, // optional
    duyet: // optional
    {
        duoc_duyet: null, // required Cho biết dịch vụ đã được duyệt hay chưa. 0: đã duyệt, 1: chờ xử lý, 2: Từ chối
        thoi_diem_duoc_duyet: null, // optional Cho biết thời điểm dịch vụ đã được duyệt
        nguoi_duyet_id: null, // optional Mã người duyệt
    },
    mo_ta: null, // optional Mô tả vận tải khách
    chi_tiet: null, // optional Chi tiết về quán
    diem_den: null, // optional Điểm đến
    thong_tin_chung: // required Thông tin vận tải khách
    {
        ten: null, // required Tên nhà hàng
        so_sao: null, // optional Số sao của địa điểm vận tải khách
        dia_chi: null, // optional Địa chỉ khách sạn - nhà hàng
        dien_thoai: null, // required Điện thoại liên hệ khách sạn - nhà hàng
        email: null, // optional Email liên hệ khách sạn - nhà hàng
        website: null, // optional Website khách sạn - nhà hàng
        doi_tuong: null, // optional Đối tượng khách hàng hướng tới
        dich_vu: [], // optional
    },
    thoi_gian_tao: null, // optional
    mediaId: null, // optional id media
    lastModificationTime: null, // optional Thời gian lần sửa bản ghi cuối cùng
    fileUploadOption: {
        AnhDaiDien: {
            limit: 1,
            accept: ".jpg, .png, .jpeg",
            dialogImageUrl: "",
            dialogVisible: false,
            fileList: []
        },
    },
};

model.validForm = {
  'dich_vu': {
    "van_tai_khach": {
      "ten": [ValidService.required],
      "anh_hien_thi": [ValidService.required],
      "mo_ta": [ValidService.required],
      "chi_tiet": [ValidService.required],
    },
    "ngon_ngu": [ValidService.required],
    "gia_tri_uu_dai": [],
    "link_mang_xa_hoi": [
      {
        "name": [],
        "link": [ValidService.checkLink]
      },
      {
        "name": [],
        "link": [ValidService.checkLink]
      },
      {
        "name": [],
        "link": [ValidService.checkLink]
      },
      {
        "name": [],
        "link": [ValidService.checkLink]
      },
      {
        "name": [],
        "link": [ValidService.checkLink]
      }
    ]
  }
}

model.tableRules = {
    data: [],
    lengthMenu: [10, 20, 50, 100, 500],
    allowPaging: true,
    allowSorting: true,
    allowSelect: false,
    showFormSearch: false,
    showUrl: true,
    total: 0,
    page: 1,
    limit: 10,
    offset: 0,
    sort: "",
    defaultSort: ["", "descending"],
    filters: "",
    recordSelected: [],
    dataSearch: {
        value: {
            "am_thuc.ten": "",
            "thong_tin_chung.dien_thoai": "",
            diem_den: "",
            'duyet.duoc_duyet': '',
        },
        valid: {
            "am_thuc.ten": [],
            "thong_tin_chung.dien_thoai": [],
            diem_den: [],
            'duyet.duoc_duyet': [],
        },
        operator: {
            "am_thuc.ten": ":regex_i:", //:regex:, $vn_text=Viêt nam
            "thong_tin_chung.dien_thoai": ":regex:",
            diem_den: ":regex:",
            'duyet.duoc_duyet': '',
        }
    }
};

export default model;
